export enum ErrorCode {
  CabinNumberMissing = 'DGX-MR-CAB-MSNG',
  ContentfulDataLoadFailed = 'DGX-CF-DATA-LOAD-FAIL',
  GetSlashCredentialsInvalid = 'DGX-GS-AUTH-INVALID',
  MpiMissing = 'DGX-MR-MPI-MSNG',
  Mxp365GeneralError = 'DGX-MR-MXP365-GNRL',
  Mxp365MissingToken = 'DGX-MR-MXP365-TKN-MSNG',
  Mxp365NotFound = 'DGX-MR-MXP365-NTFND',
  Mxp365PersonFromTokenNotFound = 'DGX-MR-MXP365-TKNPRS-NTFND',
  Mxp365NavigationFailed = 'DGX-MR-MXP365-NAV-FAIL',
  ShipCodeMissing = 'DGX-MR-SHPCDE-MSNG',
}

/**
 * Type guard to check if a string is a valid ErrorCode
 */
export function isErrorCode(value: string): value is ErrorCode {
  return Object.values(ErrorCode).includes(value as ErrorCode);
}
